import { Divider } from "@fluentui/react-components";
import ItemBar from "./ItemBar";
import { IItemBarProps, IMenuBarProps, PanelEnum } from "./Models";
import { MenuBarWrapper } from "./Styles";

export const MenuBar = ({ buttons, onSwitch, currentTabActive, theme }: IMenuBarProps) => {
    const onSelectItem = (id: string, path: string): void => {
      onSwitch(id, path);
    };
    return (
      <>
        <Divider />
        <MenuBarWrapper className="MenuBarWrapper" id={PanelEnum.MenuBar} $theme={theme}>
          {buttons?.map((item: IItemBarProps) => {
            const title = item.title;
            if (typeof title !== "undefined") {
              item.title = title;
            }
            return <ItemBar currentTab={currentTabActive} theme={theme} key={item.id} {...item} onSelect={(id, path) => (!item.disabled ? onSelectItem(id, path) : null)} />;
          })}
        </MenuBarWrapper>
      </>
    );
  };